export default __webpack_public_path__ + "static/media/logo192x192.6bbd3ef1.png";